import api from './api';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

// Fire impression on scoreboard mount — backend dedups per IP per day
export async function trackImpression(eventId) {
  try {
    await api.post('/analytics/impression', { event_id: eventId });
  } catch (err) {
    console.warn('Impression tracking failed:', err);
  }
}

// Fire click event — sponsor logo or advert board panel
export async function trackClick({ eventId, clickType, sponsorId, advertBoardId, pageContext }) {
  try {
    await api.post('/analytics/click', {
      event_id: eventId,
      click_type: clickType,
      sponsor_id: sponsorId,
      advert_board_id: advertBoardId,
      page_context: pageContext || 'scoreboard'
    });
  } catch (err) {
    console.warn('Click tracking failed:', err);
  }
}

// Build the logged-through sponsor redirect URL
export function sponsorRedirectUrl(sponsorId, eventId) {
  return `${API_BASE}/analytics/sponsor-redirect/${sponsorId}?event_id=${eventId}`;
}
